<template>
  <div class="timeout-wrap">
    <div class="timeout-header">
      <div class="timeout-logo"></div>
      <div class="timeout-title">六六脑<sup>&#174;</sup>&nbsp;&nbsp;科学健脑</div>
    </div>
    <div class="timeout-content">
      <div class="timeout-pic"></div>
      <div class="timeout-warning">
        <p>登录超时，<span>{{num}}</span>秒后自动转入登录</p>
        <p>由于您长时间未在系统操作，为了您帐号的安全，需要重新登录。</p>
      </div>
      <div class="timeout-btn">
        <button @click="toLogin">重新登录</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    data(){
      return{
        num:10,
      }
    },
    mounted() {
      this.countDown();
    },
    methods:{
      countDown(){
        let timer = setInterval(() => {
          this.num--;
          if(this.num <= 0){
            window.location.href = "/#/login";
            clearInterval(timer);
          }
        },1000)
      },
      toLogin(){
        window.location.href = "/#/login";
      },
    }
  }
</script>
<style>
.timeout-wrap{
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 30px;
  background-color: #fff;
}
.timeout-header{
  width: 100%;
  height: 20px;
  padding-left: 30px;
}
.timeout-logo{
  width: 25px;
  height: 20px;
  background-image: url(../../assets/img/logo_gray.png);
  display: inline-block;
}
.timeout-title{
  display: inline-block;
  vertical-align:top;
  color: #B9B9B9;
  font-size: 18px;
}
.timeout-content{
  position: absolute;
  left: 50%;
  top:50%;
  transform: translate(-50%,-50%);
  width: 464px;
  height: 352px;
}
.timeout-pic{
  width: 433px;
  height: 220px;
  background-image: url(../../assets/img/Group3.png)
}
.timeout-warning{
  width: 464px;
  height: 64px;
  margin-top: 12px;
}
.timeout-warning p{
  text-align: center;
  line-height: 32px;
  font-size: 16px;
  color: #999999;
}
.timeout-btn{
  width:100%;
  height: 36px;
  margin-top: 20px;
  text-align: center;
}
.timeout-btn button{
  background: #FFFFFF;
  border: 1px solid #0A81E5;
  border-radius: 20px;
  color: #0A81E5;
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// timeoutPage.vue?53ae0430